import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setProgress, setToast } from "../../redux/slice/system";
import { setUser } from "../../redux/slice/user";
import { MemberAPI } from "../../axios/api";

import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";

export default function ModulePopSecurity({ closePrePop }) {
  const dispatch = useDispatch();
  const redux_user = useSelector((state) => state.user);
  const [isAgree, setIsAgree] = useState(false);

  const agreeAction = () => {
    if (!isAgree) {
      dispatch(
        setToast({
          severity: "warn",
          summary: "請「勾選」同意個資安全聲明",
          detail: "",
        })
      );
      return;
    }

    dispatch(setProgress(true));

    let jsonData = {
      is_agree: 1,
    };

    MemberAPI.updateMemberAgree({
      data: jsonData,
    }).then((result) => {
      let { Response } = result;

      if (Response === 1) {
        let temp = { ...redux_user.userDetail, is_agree: 1 };

        dispatch(setUser(temp));
        closePrePop({ type: "security" });
      } else {
        dispatch(
          setToast({
            severity: "error",
            summary: "送出失敗",
            detail: "",
          })
        );
      }

      dispatch(setProgress(false));
    });
  };

  return (
    <>
      <div className="px-3">
        <div className="w-full">
          <div className="text-xl line-height-3 mb-3">
            {`　　歡迎您參加運用長庚護心網站（以下簡稱本網站）進行遠距心臟復健的研究。本網站對於您個人資料之蒐集、處理及利用，研究團隊將依研究參與者同意書、人體研究相關法規及個人資料保護法相關規定辦理，並善盡資料保存及運用的責任，確保資料的隱密與安全性。`}
          </div>

          <div className="flex align-items-center text-xl text-blue-700">
            <Checkbox
              inputId="agree"
              className="mr-1"
              onChange={(e) => setIsAgree(e.checked)}
              checked={isAgree}
            ></Checkbox>
            <label htmlFor="agree">我已詳閱、瞭解並同意以上說明。</label>
          </div>

          <div className="text-center mt-4">
            <Button
              className="p-button-success px-4"
              type="button"
              label="確認"
              onClick={() => agreeAction()}
            />
          </div>
        </div>
      </div>
    </>
  );
}
